import {Outlet, Route, Routes} from "react-router-dom";
import {Urls} from "component/const/Urls";
import TestShort from "./Short/TestShort";
import TestTrans from "./Trans/TestTrans";
import TestPrompt from "./Prompt/TestPrompt";

export const Test = () => {

    return (<div id={"root-element"}>
        <Routes>
            <Route path={Urls.short} element={<TestShort/>}/>
            <Route path={Urls.trans} element={<TestTrans/>}/>
            <Route path={Urls.prompt} element={<TestPrompt/>}/>
        </Routes>
        <Outlet/>
        {/*<Memo/>*/}
    </div>)
}